import { render, staticRenderFns } from "./Inspections.vue?vue&type=template&id=4b1f85b7&scoped=true&"
import script from "./Inspections.vue?vue&type=script&lang=ts&"
export * from "./Inspections.vue?vue&type=script&lang=ts&"
import style0 from "./Inspections.vue?vue&type=style&index=0&id=4b1f85b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f85b7",
  null
  
)

export default component.exports